var _use, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 8,
    y: 8,
    width: "84px",
    height: "84px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "84px",
    height: "84px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADKUlEQVR4nO3cPU8UURiG4fusaMQCo4UxsTAW2mAnhV/RUkt/g4mV4s/AaGkojIUJ2pOYGLWyQVhDaInGEI2FjYVRNCQW8FjMjCwrsOzuO3Pm470TCgKZOefizMzuMBDwAJB0ELgFTABfgTngTQjhT9SBVTFJY5Lm9X8/JT2VNBF7jJUpxWxvg9ndc0lnYo+31PWBmbUmaVJSiD320jUAZmfPJO2PPYfSNCRm1gtHBSQdMsDMmlHTD39J940ws+7EnlPUJL03Bl2TdDrbfivm5CL123h7o8CD7JMmgj7KYZs3JJ3LYbvlT1KQNG182EvSTOy5RStFfWgM+kPSgdhzi5byWanXRmJPzDolrwsvA6eAxRDCh+2+L4QgSZPpp7eNdn/VaDvlSMk7oFcdK2Zd0pR2efFtvFKfFDnfXEsxF3aY6HRBqFYrPW49MItCfavkJnW1U383Oh7vAXWQq/+CpLEi551LfWLmhdpoTGtUxzREdUxD1Fph9rqa99terv43JS1KWpZ0T9JokfPOJdmuzO52Xam1K2fMZqEWhNkMVOVzzuzV1DBjLu1PQ8lV9DVwoeBdbwDjO92l6lUpfwUSERMSk4GfZSodaGTMrM8R921XpHNmdy9jO5ikYq/mO7Uk6Uhsi6FzTMMc0zDHNMwxDXNMwxzTMMc0rCSYtbrT7pgWOaZhjmmYYxrmmIY5pmGOaZhjGuaYhjmmYY5pmGMa5piGOaZhjmmYYxrmmIY5pmGOaZhjGuaYhjmmcZJmHXPwtjxjL+kkydO7sZ69bwPXQwirkfY/dN2PhF/BMYeqG/RilFHUBBPKAVobTOg4vNMLwXdgX4H7rxUmbF2h53HMoesELfJwryUmbAUt6g+taosJ6TlUUovk/Hk45/3VGhM2V+hZHNOkDPRSzvtpBCZsguZ5/mwM5r8krfiNDqMkHXNMu1rkc/5s3mGe1iJ5h2SVgFkaigkwQvKfYAdtHVgG5oEFYC6E8MViYFVtBPjYx/evkhzObRLAdyGEX3kMrKoFSceBJeDENl9fIYHLPpZDCBsFjq9yZW89jwJ3gXHgEwleO4TwLeLYKtlfivNt3aVLFUgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.762afa51c5527a4d806a120fa47a6cd3.svg";
export { ForwardRef as ReactComponent };